export const AUTH_NOT_CHECKED = 'not checked';
export const AUTH_IN_PROGRESS = 'in progress';
export const AUTH_YES = 'yes';
export const AUTH_NO = 'no';
